export const diverseOptions = [
  { id: 1, value: "Not Provided", databaseName: "not_provided" },
  { id: 2, value: "Yes", databaseName: "yes" },
  { id: 3, value: "No", databaseName: "no" },
]
